import { render, staticRenderFns } from "./ToolbarItem.vue?vue&type=template&id=0185a223&scoped=true"
import script from "./ToolbarItem.vue?vue&type=script&lang=js"
export * from "./ToolbarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0185a223",
  null
  
)

export default component.exports